import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-reject-reason-dialog',
  template: `
    <h1 mat-dialog-title class="reject-dialog-title">Select a Rejection Reason</h1>
    <div mat-dialog-content class="reject-dialog-content">
      <mat-form-field appearance="outline" class="reject-dialog-field">
        <mat-label>Reason</mat-label>
        <mat-select [(value)]="selectedReason" panelClass="reject-reason-panel">
          <mat-option *ngFor="let reason of data.reasons" [value]="reason">
            {{ reason }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div mat-dialog-actions align="end" class="reject-dialog-actions">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-flat-button color="warn" (click)="onConfirm()" [disabled]="!selectedReason">Confirm</button>
    </div>
  `,
  styleUrls: ['./reject-reason-dialog.component.css']
})
export class RejectReasonDialogComponent {
  selectedReason: string;
  constructor(
    public dialogRef: MatDialogRef<RejectReasonDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { reasons: string[] }
  ) {}

  onConfirm(): void {
    this.dialogRef.close(this.selectedReason);
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
